import React from 'react';
import { connect } from 'react-redux';
import SortDropDown from './SortDropDown';

import './styles.scss';

const ListingSorter = ({ listingSorters, seoFilters, packageCount, metadataIsLoading }) => (
  <>
    <div className="sortedByWrapper">
      {/* {!!packages?.length && (activeTab?.totalPackageCount || packagesCount) && (
        <>
          {' '}
          ({packages.length}/{activeTab?.totalPackageCount || packagesCount} Packages)
        </>
      )} */}
      {metadataIsLoading && !listingSorters?.length ? (
        <div className="sortLoader" />
      ) : (
        <SortDropDown listingSorters={listingSorters} seoFilters={seoFilters} />
      )}
    </div>
  </>
);

const mapStateToProps = ({ metadata, seo }) => ({
  listingSorters: metadata?.listingSorters,
  metadataIsLoading: metadata?.isLoading,
  seoFilters: seo?.filters,
});

export default connect(mapStateToProps, null)(ListingSorter);
